/**
 * ViewAsBanner
 *
 * Amber sticky strip shown while an admin is impersonating another
 * user, with the single way back to the admin's own session.
 */

import { endImpersonation, getImpersonatedName, isImpersonating } from '../utils/impersonation';
import { Box, Button, Typography } from './ui';
import { VisibilityIcon } from './icons';

export default function ViewAsBanner() {
  if (!isImpersonating()) return null;

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: (theme) => theme.zIndex.appBar + 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5,
        py: 0.75,
        px: 2,
        bgcolor: 'warning.softBg',
        borderBottom: '1px solid #ffd970',
        color: 'warning.softText',
        flexWrap: 'wrap',
      }}
    >
      <VisibilityIcon fontSize="small" sx={{ color: 'inherit' }} />
      <Typography variant="body2" sx={{ color: 'inherit' }}>
        Impersonating <strong>{getImpersonatedName() || 'user'}</strong>
      </Typography>
      <Button
        size="small"
        variant="outlined"
        onClick={endImpersonation}
        sx={{
          textTransform: 'none',
          py: 0.25,
          px: 1.5,
          fontSize: '0.8rem',
          borderColor: '#c89c00',
          color: 'warning.softText',
          '&:hover': { borderColor: 'warning.softText', bgcolor: 'warning.softBg' },
        }}
      >
        Return to admin
      </Button>
    </Box>
  );
}
